// presignedURL puede venir undefined desde callers que lo derivan de una query
// opcional (p.ej. billing); se preserva el comportamiento previo (fetch falla y
// cae en catch) sin obligar a los callers a guardar el valor.
const putS3 = async (presignedURL: string | undefined, file: BodyInit | null) => {
  return new Promise((resolve, reject) => {
    fetch(presignedURL as string, {
      method: 'PUT',
      body: file,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export default putS3;
